export interface SortSelectionOption<T> {
  displayName: string;
  columnDef: keyof T;
}
